import { forwardRef } from 'react';
import Avatar, { type AvatarProps } from '@mui/material/Avatar';

import { IconUser } from '@/components/icon/tabler/IconUser';

/** MUI v6 has no fallback icon slot. Preserve initials and replace only its generic person. */
const OutlineAvatar = forwardRef<HTMLDivElement, AvatarProps>(
  ({ children, alt, ...props }, ref) => (
    <Avatar {...props} alt={alt} ref={ref}>
      {children ?? (alt ? alt[0] : <IconUser />)}
    </Avatar>
  ),
);
OutlineAvatar.displayName = 'OutlineAvatar';

export default Object.assign(OutlineAvatar, { muiName: 'Avatar' });
